import React from "react";
import { Label, Tree, TreeItem, TreeItemLayout } from "@fluentui/react-components";
import VisitConceptTreeLeaf from "../Atom/VisitConceptTreeLeaf";

interface VisitConceptTreeBranchProps {
    ContractId: number; // Assuming ContractId is needed for the modal
    formName?: string;
    itemNumber?: number;
    label: React.ReactNode;
    value: string;
    children?: React.ReactNode;
    leaves?: { label: string; value?: string | number; realized?: boolean; isPayable: boolean; isProcedure: boolean; type?: string }[];
    formType?: string;
    icon?: React.ReactElement | null;
    hasRealized?: boolean;
    isPayable?: boolean;
    isProcedure?: boolean;
    extraFormType: number | null | undefined;
}

const VisitConceptTreeBranch: React.FC<VisitConceptTreeBranchProps> = ({ ContractId, formName, itemNumber, label, value, children, leaves, formType, icon, hasRealized, extraFormType}) => {
    const iconStyled = icon ? React.cloneElement(icon, { style: { ...(icon.props.style || {}), color: hasRealized ? 'green' : icon.props.style?.color } }) : null;
    return (
        <TreeItem itemType="branch" value={value}>
            <TreeItemLayout iconBefore={iconStyled ? { children: iconStyled } : undefined}>
                <Label style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: hasRealized ? 600 : 400 }}>
                    {label}        
                </Label>
            </TreeItemLayout>
            <Tree>
                {leaves && leaves.map((leaf) => (
                    <VisitConceptTreeLeaf
                        ContractId={ContractId}
                        formName={formName}
                        itemNumber={itemNumber}
                        key={leaf.label + String(leaf.value)}
                        label={leaf.label}
                        value={leaf.value}
                        realized={leaf.realized}
                        isPayable={leaf.isPayable}
                        isProcedure={leaf.isProcedure}
                        type={leaf.type}
                    />
                ))}
                {children}
            </Tree>
        </TreeItem>
    );
};

export default VisitConceptTreeBranch;
